import { render, staticRenderFns } from "./Observador.vue?vue&type=template&id=15a9adcc&scoped=true"
import script from "./Observador.vue?vue&type=script&lang=js"
export * from "./Observador.vue?vue&type=script&lang=js"
import style0 from "./Observador.vue?vue&type=style&index=0&id=15a9adcc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a9adcc",
  null
  
)

export default component.exports